import React from 'react';

export const IconButton = ({ icon, small = false, fill = false, level = 'primary', size = '', description = null, className = '', children = null, ...other }) => {
  const sizes = {
    'sm': 'h6 align-middle m-0',
    'lg': 'h2 m-0',
    'xl': 'h1 m-0',
  };
  
  if(small) {
    size = 'sm';
  }

  const sizeClass = size ? (sizes[size] || '') : '';

  const content = <>
    <i
      className={`material-icons align-middle text-${fill ? 'white' : level || 'default '} ${sizeClass} ${children ? 'mr-1' : ''}`}>
      {icon}
    </i>
    {children ? <span className={'align-middle mr-1'}>{children}</span> : null}
  </>

  const fillStyle = fill ? `btn-${level} text-white` : `${!other.href ? 'btn-link' : ''} text-${level}`;

  if (other.href) {
    return <a {...other} className={`${fillStyle} ${className}`} title={description || other.title}>
      {content}
    </a>;
  } else {
    return <button {...other} className={`btn btn-xs ${fillStyle} ${className}`} type='button' title={description || other.title}>
      {content}
    </button>;
  }
};
